import Duration from 'duration-js';
import isNil from 'lodash/isNil';

export const msToDuration = (ms?: number) => {
  if (isNil(ms)) return '';

  return new Duration(ms).toString();
};
